/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function GradientRadialClosestCorner(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'GradientRadialClosestCorner',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 14 * scale,
      viewBox: '0 0 17 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".5","fill":"#41A2F2","d":"M2 11.2c.3.3.7.6 1 .8h7c1.8-1.2 3-3.2 3-5.5 0-1.7-.7-3.3-1.8-4.5H2z"}),createElement('path', {"fill":"#7AB8FF","d":"m7.4 6.6-5-5-.8.8 5 5"}),createElement('path', {"opacity":".4","fill":"currentColor","d":"M2 12V2h13v10zM16 1H1v12h15z"}),createElement('circle', {"fill":"currentColor","cx":"6.5","cy":"6.5","r":"1.5"}),createElement('path', {"fill":"currentColor","d":"M1 1h2v2H1z"}))
}
